import { defineMessages } from 'react-intl'

const messages = {
  title: {
    id: 'app.components.order-selector.title',
    defaultMessage: 'Show open orders:',
  },
  today: {
    id: 'app.components.order-selector.today',
    defaultMessage: 'Today',
  },
  tomorrow: {
    id: 'app.components.order-selector.tomorrow',
    defaultMessage: 'Tomorrow',
  },
  later: {
    id: 'app.components.order-selector.later',
    defaultMessage: 'Later',
  },
}

export default defineMessages(messages)
